<script lang="ts">
  import LinkifyingFormatter from '@/utils/linkifying-formatter'

  let {
    text = $bindable(''),
    classes = ''
  } = $props()

  let formattedText = $derived(new LinkifyingFormatter(text).formattedText())
</script>

<div class="LinkifyingPhonePreview keyword-confirmation-preview {classes}">
  <div class="keyword-confirmation-text">
    <div>{@html formattedText}</div>
  </div>
  <div class="keyword-confirmation-preview-phone"></div>
</div>
